import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  style: {
    "text-align": "center"
  }
};
var _hoisted_2 = ["src"];
var _hoisted_3 = ["src"];
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  "class": "menu-footer"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  key: 0,
  "class": "front-version"
};
var _hoisted_8 = {
  style: {
    "font-weight": "500"
  }
};
var _hoisted_9 = {
  style: {
    "margin-top": "8px"
  }
};
var _hoisted_10 = {
  style: {
    "margin-top": "8px"
  }
};
var _hoisted_11 = {
  style: {
    "margin-top": "8px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_menu_item = _resolveComponent("a-menu-item");
  var _component_a_sub_menu = _resolveComponent("a-sub-menu");
  var _component_a_menu = _resolveComponent("a-menu");
  var _component_a_form_item = _resolveComponent("a-form-item");
  var _component_a_input_password = _resolveComponent("a-input-password");
  var _component_a_form = _resolveComponent("a-form");
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_a_menu, {
    id: "leftMenu",
    "selected-keys": _ctx.selectedKeys,
    "onUpdate:selectedKeys": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.selectedKeys = $event;
    }),
    "open-keys": _ctx.openKeys,
    "onUpdate:openKeys": _cache[2] || (_cache[2] = function ($event) {
      return _ctx.openKeys = $event;
    }),
    mode: "inline",
    theme: "dark",
    "inline-collapsed": _ctx.collapsed,
    style: _normalizeStyle({
      width: _ctx.collapsed ? '' : '228px'
    }),
    onClick: _ctx.menuLink
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        "class": "menu-logo",
        src: _ctx.themeData.darkLogoList
      }, null, 8, _hoisted_2)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, function (menu) {
        return _openBlock(), _createElementBlock(_Fragment, null, [!menu.leaves ? (_openBlock(), _createBlock(_component_a_menu_item, {
          key: menu.linkTo
        }, {
          icon: _withCtx(function () {
            return [_createElementVNode("img", {
              "class": "menu-icon",
              src: menu.icon
            }, null, 8, _hoisted_3)];
          }),
          "default": _withCtx(function () {
            return [_createElementVNode("span", null, _toDisplayString(menu.title || menu.name), 1)];
          }),
          _: 2
        }, 1024)) : (_openBlock(), _createBlock(_component_a_sub_menu, {
          key: menu.subKey
        }, {
          icon: _withCtx(function () {
            return [_createElementVNode("img", {
              "class": _normalizeClass(menu.id === 14 ? 'menu-icon-exchange' : menu.id === 17 ? 'menu-icon-manage' : 'menu-icon'),
              src: menu.icon
            }, null, 10, _hoisted_4)];
          }),
          title: _withCtx(function () {
            return [_createElementVNode("span", {
              "class": _normalizeClass(menu.id === 14 ? 'menu-text-exchange' : menu.id === 17 ? 'menu-text-manage' : '')
            }, _toDisplayString(menu.title || menu.name), 3)];
          }),
          "default": _withCtx(function () {
            return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.leaves, function (leave) {
              return _openBlock(), _createBlock(_component_a_menu_item, {
                key: leave.linkTo
              }, {
                "default": _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(leave.title || leave.name), 1)];
                }),
                _: 2
              }, 1024);
            }), 128))];
          }),
          _: 2
        }, 1024))], 64);
      }), 256)), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        "class": "btn-collapse",
        onClick: _cache[0] || (_cache[0] = function () {
          return _ctx.toggleCollapsed && _ctx.toggleCollapsed.apply(_ctx, arguments);
        })
      }, [_createElementVNode("img", {
        "class": "collapse-icon",
        src: _ctx.iconMenuNeutral
      }, null, 8, _hoisted_6)]), _ctx.frontProVersion ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.frontProVersion), 1)) : _createCommentVNode("", true)])];
    }),
    _: 1
  }, 8, ["selected-keys", "open-keys", "inline-collapsed", "style", "onClick"]), _createVNode(_component_a_modal, {
    visible: _ctx.visible,
    "mask-closable": false,
    title: _ctx.$t('pages_main_041'),
    "confirm-loading": _ctx.loading,
    onOk: _ctx.passwordUpdate,
    onCancel: _ctx.updateCancel
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_a_form, {
        ref: "editRef",
        "label-align": "left",
        model: _ctx.editForm,
        rules: _ctx.editRules,
        "label-col": {
          span: 5
        }
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_a_form_item, {
            "wrapper-col": {
              offset: 5
            },
            style: {
              "margin-top": "-8px"
            }
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('pages_user_066')), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('pages_user_067')), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('pages_user_068')), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('pages_user_069')), 1)];
            }),
            _: 1
          }), _createVNode(_component_a_form_item, {
            name: "oldPassword",
            label: _ctx.$t('pages_main_042')
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_a_input_password, {
                value: _ctx.editForm.oldPassword,
                "onUpdate:value": _cache[3] || (_cache[3] = function ($event) {
                  return _ctx.editForm.oldPassword = $event;
                }),
                placeholder: _ctx.$t('common_text_006') + _ctx.$t('pages_main_042')
              }, null, 8, ["value", "placeholder"])];
            }),
            _: 1
          }, 8, ["label"]), _createVNode(_component_a_form_item, {
            name: "newPassword",
            label: _ctx.$t('pages_user_058')
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_a_input_password, {
                value: _ctx.editForm.newPassword,
                "onUpdate:value": _cache[4] || (_cache[4] = function ($event) {
                  return _ctx.editForm.newPassword = $event;
                }),
                placeholder: _ctx.$t('common_text_006') + _ctx.$t('pages_user_058')
              }, null, 8, ["value", "placeholder"])];
            }),
            _: 1
          }, 8, ["label"]), _createVNode(_component_a_form_item, {
            name: "secPassword",
            label: _ctx.$t('pages_user_059')
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_a_input_password, {
                value: _ctx.editForm.secPassword,
                "onUpdate:value": _cache[5] || (_cache[5] = function ($event) {
                  return _ctx.editForm.secPassword = $event;
                }),
                placeholder: _ctx.$t('common_text_006') + _ctx.$t('pages_user_059')
              }, null, 8, ["value", "placeholder"])];
            }),
            _: 1
          }, 8, ["label"])];
        }),
        _: 1
      }, 8, ["model", "rules"])];
    }),
    _: 1
  }, 8, ["visible", "title", "confirm-loading", "onOk", "onCancel"])]);
}